import { render, staticRenderFns } from "./DevelopersManage.vue?vue&type=template&id=45eee6b3&scoped=true&"
import script from "./DevelopersManage.vue?vue&type=script&lang=js&"
export * from "./DevelopersManage.vue?vue&type=script&lang=js&"
import style0 from "./DevelopersManage.vue?vue&type=style&index=0&id=45eee6b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eee6b3",
  null
  
)

export default component.exports